import type { AiBrowsingEvent } from "@/lib/ai/storage/types";

export interface AiRouteMeta {
	routeGroup: string;
	entityType?: AiBrowsingEvent["entityType"];
	entityId?: string;
}

export function parseAiRouteMeta(pathname: string): AiRouteMeta {
	if (pathname.startsWith("/plaza/token/")) {
		return {
			routeGroup: "token",
			entityType: "token",
			entityId: pathname.split("/").pop() ?? undefined,
		};
	}

	if (pathname.startsWith("/address/")) {
		return {
			routeGroup: "address",
			entityType: "address",
			entityId: pathname.split("/").pop() ?? undefined,
		};
	}

	if (pathname.startsWith("/address")) {
		return {
			routeGroup: "address",
			entityType: "address",
		};
	}

	if (pathname.startsWith("/data") || pathname.startsWith("/scan")) {
		return {
			routeGroup: "market",
			entityType: "market",
			entityId: pathname.replace(/^\//, "") || "market",
		};
	}

	if (pathname.startsWith("/discover")) {
		return {
			routeGroup: "discover",
			entityType: "discover",
			entityId: pathname.replace(/^\//, "") || "discover",
		};
	}

	if (pathname.startsWith("/profile")) {
		return {
			routeGroup: "profile",
			entityType: "profile",
			entityId: pathname.replace(/^\//, "") || "profile",
		};
	}

	if (pathname.startsWith("/plaza")) {
		return {
			routeGroup: "plaza",
			entityType: "market",
			entityId: pathname.replace(/^\//, "") || "plaza",
		};
	}

	return {
		routeGroup: "general",
	};
}

export function buildAiEntityKey(routeMeta: Pick<AiRouteMeta, "entityType" | "entityId" | "routeGroup">) {
	if (!routeMeta.entityType) {
		return null;
	}

	const entityId = routeMeta.entityId ?? routeMeta.routeGroup;
	if (!entityId) {
		return null;
	}

	return `${routeMeta.entityType}:${entityId}`;
}
